import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Instagram, LinkedIn } from "@mui/icons-material"

import { useState } from "react"

const TeamCard = (props) => {
    const { member } = props;
    const count = member.countInLine;

    const [imgLoaded, setImgLoaded] = useState(false);

    return (
        <div className={`team-card-wrapper team-count-${count}`} data-loaded={true}>
            <div className="team-card">
                <div className={`team-card-img${imgLoaded ? ' team-card-overlay' : ''}`} data-title={member.name}>
                    {
                        !imgLoaded
                        && <h2>Loading...</h2>
                    }
                    <img
                        src={member.img}
                        title={member.name}
                        alt={member.name}
                        onLoad={() => setImgLoaded(true)}
                    />
                </div>
                <div className='team-card-data'>
                    <div className="team-card-personalInfo">
                        <div className="card-info flex flex-away">
                            <div className="capitalize">
                                {member.name}
                            </div>
                            <div className="socialsList gap-1">
                                {
                                    member.instagram?.length
                                        ?
                                        <a
                                            title='Instagram'
                                            href={member.instagram}
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            <Instagram />
                                        </a>
                                        :
                                        <></>
                                }
                                {
                                    member.linkedin?.length
                                        ?
                                        <a
                                            title='LinkedIn'
                                            href={member.linkedin}
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            <LinkedIn />
                                        </a>
                                        :
                                        <></>
                                }
                            </div>
                        </div>
                        <div className="card-position uppercase">
                            {member.position}
                        </div>
                    </div>

                    {
                        member.quote?.length
                            ?
                            <div className='team-card-data-oneLiner'>
                                <FontAwesomeIcon icon={faQuoteLeft} />
                                <p>{member.quote}</p>
                            </div>
                            :
                            <></>
                    }
                </div>

            </div>
        </div>
    )
}

export default TeamCard